module.exports = __webpack_public_path__ + "img/micro_wheather_station.8295fd4f.jpg";